<template>
    <div>
      <el-autocomplete
        class="inline-input"
        v-model="state"
        :fetch-suggestions="querySearch"
        placeholder="请描述你的问题"
        @select="handleSelect"
        clearable
      ></el-autocomplete>
    </div>
</template>

<script>
  import {
    SearchKnowledge,
  } from "@/api/modules/basicData/task";
  import { getToken } from "../../util/auth";
  const cookieUser = getToken();
  export default {
    name: "selectKnowledge",
    data() {
      return {
        restaurants: [],
        state: '',
      };
    },
    mounted() {
    },
    watch: {
      state(val) {
        this.$emit("getValue", val)
        this.SearchKnowledge()
      }
    },
    methods: {
      SearchKnowledge() {
        let value = []
        let val = {
          PageIndex: 1,
          pageSize: 10,
          SearchTxt: this.state,
          Para: {
            SortStyle: 0,
            CurPerson: {
              ID: cookieUser.userId,
              NAME: cookieUser.realName,
              DEPTID: cookieUser.departmentId,
              DEPTNAME: cookieUser.departmentName,
              COMPANYID: cookieUser.companyId,
              COMPANYNAME: cookieUser.companyName,
            }
          }
        }
        SearchKnowledge(val).then(res => {
          console.log(res.Items)
          res.Items.filter( e => {
            let v = {
              value: e.TITLE,
              address: e.CREATECOMPANYNAME
            }
            value.push(v)
          })
        })
        this.restaurants = value
        console.log("SearchKnowledge", value)
      },
      querySearch(queryString, cb) {
        console.log("queryString",queryString, this.restaurants)
        var restaurants = this.restaurants;
        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);
      },
      createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      handleSelect(item) {
        console.log(item);
      }
    },
  }
</script>

<style scoped>
.inline-input{
  width: 100%;
}
</style>
